const useErrorPush = (errorMessage, condition) => {
  if (condition) {
    return window.dataLayer.push({
      event: 'Error',
      errorMessage,
    });
  }
  return false;
};

export default useErrorPush;
